module.exports = __webpack_public_path__ + "img/pengumuman-alt.c9439317.svg";